import { ssoRequiredCodeFor, type SsoProviderSlug } from '@instanexus/contracts';
import { errorMessage, useTranslation } from '@instanexus/i18n';
import { Alert, AlertDescription, AlertTitle, Button } from '@instanexus/ui';
import type { ReactElement } from 'react';

export interface CompanySignInNoticeProps {
  readonly provider: SsoProviderSlug;
  /** Enterprise only: the IdP's display name from discovery; null/absent gives the generic text. */
  readonly label?: string | null;
  readonly onUseDifferentEmail: () => void;
}

/** Shown in place of the password form when the person's company requires one provider. */
export function CompanySignInNotice({
  provider,
  label = null,
  onUseDifferentEmail,
}: CompanySignInNoticeProps): ReactElement {
  const { t } = useTranslation('auth');
  return (
    <div className="flex flex-col gap-2">
      <Alert variant="info" role="alert">
        <AlertTitle>{t('central.companyRequired.title')}</AlertTitle>
        <AlertDescription>
          {provider === 'enterprise' && label !== null
            ? t('central.companyRequired.enterpriseNamed', { name: label })
            : errorMessage(t, ssoRequiredCodeFor(provider))}
        </AlertDescription>
      </Alert>
      <Button type="button" variant="link" className="self-start" onClick={onUseDifferentEmail}>
        {t('central.companyRequired.useDifferentEmail')}
      </Button>
    </div>
  );
}
